
import { ISanPhamImportRequest } from "../../model/request/san-pham/ISanPhamImportRequest"
import { ISanPhamChiTiet } from "../../model/respone/san-pham/ISanPhamChiTiet"
import { apiClient } from "../apiClient"

export const SAN_PHAM_CHI_TIET_API_RESOURCE = "san-pham-chi-tiet"
export const sanPhamChiTietApi = {
    SelectAll: () => apiClient.get(`${SAN_PHAM_CHI_TIET_API_RESOURCE}`),
    SelectAllWithInventory: () => apiClient.get(`${SAN_PHAM_CHI_TIET_API_RESOURCE}/with-inventory`),
    Insert: (payload: ISanPhamChiTiet) => apiClient.post(`${SAN_PHAM_CHI_TIET_API_RESOURCE}`,payload),
    Update: (payload: ISanPhamChiTiet) => apiClient.put(`${SAN_PHAM_CHI_TIET_API_RESOURCE}`,payload),
    Delete: (id: number) => apiClient.delete(`${SAN_PHAM_CHI_TIET_API_RESOURCE}/${id}`),
    LoadFromExcel(request: FormData) {
        return apiClient.upload(`${SAN_PHAM_CHI_TIET_API_RESOURCE}/import/load-from-excel`, request)
    },
    SaveDataExcel(request: ISanPhamImportRequest) {
        return apiClient.post(`${SAN_PHAM_CHI_TIET_API_RESOURCE}/import/save-data-excel`, request)
    }
}